<template>
    <span class="bwc" :class="`is-${tone}`">
        <span class="bwc-label"><slot>{{ label }}</slot></span>
        <button type="button" class="bwc-close" :title="closeLabel || $t('common.close')"
            :aria-label="closeLabel || $t('common.close')" @click="$emit('remove')">
            <i class="bi bi-x"></i>
        </button>
    </span>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

// Odcienie dostępne w motywie Aurora; wariant Bootstrapa (np. success, danger) jest mapowany na jeden z nich
const variantTones: Record<string, string> = {
    primary: "indigo",
    secondary: "indigo",
    success: "emerald",
    danger: "rose",
    warning: "amber",
    info: "cyan",
};

export default defineComponent({
    name: "BadgeWithClose",
    props: {
        label: { type: String, required: true }, // Tekst w badge (gdy brak treści w slocie)
        variant: { type: String, default: "primary" }, // Kolor badge (np. primary, success, danger)
        closeLabel: { type: String, default: "" }, // Opis przycisku zamykania dla czytników ekranu
    },
    emits: ["remove"], // Wysyła event po kliknięciu "X"
    setup(props) {
        const tone = computed(() => variantTones[props.variant] ?? "indigo");
        return { tone };
    },
});
</script>

<style scoped>
.bwc {
    --bwc-bg: #eef2ff;
    --bwc-fg: #4338ca;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 5px 4px 11px;
    border-radius: 999px;
    background: var(--bwc-bg);
    color: var(--bwc-fg);
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.3;
    white-space: nowrap;
}

.bwc.is-cyan { --bwc-bg: #ecfeff; --bwc-fg: #0e7490; }
.bwc.is-rose { --bwc-bg: #fff1f2; --bwc-fg: #be123c; }
.bwc.is-amber { --bwc-bg: #fffbeb; --bwc-fg: #b45309; }
.bwc.is-emerald { --bwc-bg: #ecfdf5; --bwc-fg: #047857; }

.bwc-close {
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    display: inline-grid;
    place-items: center;
    background: rgba(255, 255, 255, 0.7);
    color: inherit;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.12s, transform 0.12s;
}

.bwc-close:hover {
    background: #fff;
    transform: scale(1.1);
}

.bwc-close:focus-visible {
    outline: 2px solid var(--bwc-fg);
    outline-offset: 1px;
}
</style>
